// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2945G","infoBtn":"quickbooks_infoBtn__1h0pE","formBox":"quickbooks_formBox__1hAi6","formFooter":"quickbooks_formFooter__Qcty_"};